

























































import { Vue, Component } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import { StateChanger } from 'vue-infinite-loading'
import { Message, messageTypeClassNames, MessageUser } from '@/types/message'
import { User, isRelative } from '@/types/user'
import dayjs from 'dayjs'

@Component({
  components: {
    InfiniteLoading: () => import('vue-infinite-loading'),
    UserIcon: () => import('@/components/common/UserIcon.vue'),
    Loading: () => import('@/components/common/loadings/Index.vue')
  }
})
export default class MessageHistory extends Vue {
  $store!: ExStore

  get hasNext() {
    return this.$store.getters['message/hasHistoryNext']
  }

  get messages() {
    return this.$store.state.message.history.messages
  }

  get userInfo() {
    return this.$store.getters['user/userInfo']
  }

  async beforeCreate() {
    await this.$store.dispatch('message/updateHistory')
    const latestId = this.$store.getters['message/latestMessageUserId']
    if (!latestId) return
    try {
      this.$api.message.patchRead({ id: latestId })
      this.$store.dispatch('message/updateUnreadHistory')
    } catch (e) {
      console.error(e)
    }
  }

  beforeDestroy() {
    this.$store.commit('message/updateRecipients', [])
  }

  onNextLoad($state: StateChanger) {
    this.$store.dispatch('message/loadNextHistory').then(() => {
      if (this.hasNext) {
        $state.loaded()
      } else {
        $state.complete()
      }
    })
  }

  getMessageTypeClass(message: Message) {
    return messageTypeClassNames[message.messageTypeLevel - 1]
  }

  getDatetimeStr(message: Message) {
    return dayjs(message.registeredDatetime).format('M月D日 HH:mm')
  }

  isSelfSender(message: Message) {
    return this.isLoginUser(message.user)
  }

  isLoginUser(user: User) {
    return user.id == this.userInfo.id
  }

  getUserName(user: User) {
    if (this.isLoginUser(user)) return '自分'
    return `${user.lastName}${user.firstName}`
  }

  getSenderName(message: Message) {
    const user = message.user
    return this.getUserName(user)
  }

  getSenderOccupation(message: Message) {
    const sender = message.user
    const occ = isRelative(sender) ? '家族' : sender.occupation
    return this.isLoginUser(sender) ? '' : occ
  }

  getMessageUsers(message: Message) {
    return message.messageuserSet.filter(set => !this.isLoginUser(set.user))
  }

  getOccupationShortName(user: MessageUser) {
    if (isRelative(user)) return ''
    return user.occupation ? user.occupation.shortName : ''
  }

  getOccupationName(user: MessageUser) {
    if (isRelative(user)) return '家族'
    return user.occupation ? user.occupation.name : ''
  }

  getOccupationCode(user: MessageUser) {
    if (isRelative(user)) return ''
    return user.occupation ? user.occupation.code : ''
  }
}
